import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISkill } from "../../../Pages/Skillstrainer/ISkill";

export const AddArithmeticGameSkillSlice = createSlice({
  name: "AddArithmeticGameSkillSlice",
  initialState: {} as IReduxState<ISkill>,
  reducers: {
    addArithmeticGameSkill: (state, _: PayloadAction<ISkill>) => {
      state.isLoading = true;
    },
    successaddArithmeticGameSkill: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddArithmeticGameSkill: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddArithmeticGameSkillResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addArithmeticGameSkill,
  failureaddArithmeticGameSkill,
  successaddArithmeticGameSkill,
  clearAddArithmeticGameSkillResponse,
} = AddArithmeticGameSkillSlice.actions;

export default AddArithmeticGameSkillSlice.reducer;
